import { atomWithStorage } from 'jotai/utils';
import { FILTERS_DEFAULT_STATE } from '@/constants';
import type { ActiveFiltersType } from '@/types';
import { syncJsonStorage } from './storage';

const jsonStorage = syncJsonStorage<ActiveFiltersType>();

// Values persisted before a category existed (e.g. `relationships`, #1839)
// lack its key — backfill from the default state so every category is an array.
const filtersStorage: typeof jsonStorage = {
    ...jsonStorage,
    getItem: (key, initialValue) => ({ ...FILTERS_DEFAULT_STATE, ...jsonStorage.getItem(key, initialValue) }),
};

export const activeFiltersAtom = atomWithStorage<ActiveFiltersType>('filters', FILTERS_DEFAULT_STATE, filtersStorage, {
    getOnInit: true,
});
